import { Component, } from '@angular/core';

@Component({
  selector: 'ranking-app',
  template: `<router-outlet></router-outlet>`
})

export class RankingComponent {
  constructor() {}
}